import React from 'react'
import { Segment } from 'components/segment/Segment';
import SEO from 'components/seo';

export default () => (
    <>
        <SEO title="Tutorial page" />
        <Segment>
            <div  style={{minHeight:'100vh', display:'flex', justifyContent:'center', alignItems:'center'}}>
                This is Tutorials page.
            </div>
        </Segment>
    </>
    )
